// extracted by mini-css-extract-plugin
export default {"root":"Card_root__ht0xd","small":"Card_small__TsaFs","medium":"Card_medium__MBCLt","full":"Card_full__gK3kW","loadingWrapper":"Card_loadingWrapper__dnH9F"};